import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-251ad402")

_pushScopeId("data-v-251ad402")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" мы обязательно свяжемся с Вами в ближайшее время ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "grid fluid py-3" }
const _hoisted_6 = { class: "col-12 md:col-6" }
const _hoisted_7 = { class: "p-input-icon-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_9 = { class: "col-12 md:col-6" }
const _hoisted_10 = { class: "p-input-icon-left" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "pi pi-phone" }, null, -1)
const _hoisted_12 = { class: "mt-0" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" я соглашаюсь ")
const _hoisted_14 = /*#__PURE__*/_createVNode("a", { href: "https://well.ru/about/acceptance_personal_data.php" }, " с политикой компании ООО «Велл» ", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" по обработке моих персональных данных ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_InputMask = _resolveComponent("InputMask")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Фин.показатели франшизы",
    visible: _ctx.isPresentationOrderRequested,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isPresentationOrderRequested = $event)),
    modal: true,
    style: {"max-width":"1366px"}
  }, {
    footer: _withId(() => [
      (!_ctx.isPresentationSent)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Скачать фин.показатели",
            icon: "pi pi-download",
            class: "mr-0",
            onClick: _ctx.saveOrder,
            autofocus: ""
          }, null, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Хорошо",
            icon: "pi pi-check",
            onClick: _ctx.closeOrder,
            autofocus: ""
          }, null, 8, ["onClick"]))
    ]),
    default: _withId(() => [
      (_ctx.isPresentationSent)
        ? (_openBlock(), _createBlock("p", _hoisted_1, [
            _createTextVNode(" Спасибо за проявленный интерес, " + _toDisplayString(_ctx.fields.username) + ", ", 1),
            _hoisted_2,
            _hoisted_3
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (!_ctx.isMobile)
              ? (_openBlock(), _createBlock("p", _hoisted_4, "Чтобы подробнее ознакомиться с нашей франшизой, оставьте свои контактные данные, и наш менеджер свяжется с вами"))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_InputText, {
                    id: "username",
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldErrors.username && _ctx.validate())),
                    modelValue: _ctx.fields.username,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fields.username = $event)),
                    class: ["mr-1 mb-1", { 'invalid': _ctx.fieldErrors.username }],
                    placeholder: "Имя *",
                    autofocus: ""
                  }, null, 8, ["modelValue", "class"])
                ]),
                (_ctx.fieldErrors.username)
                  ? (_openBlock(), _createBlock(_component_InlineMessage, {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validate())),
                      class: "error"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.fieldErrors.username), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_InputMask, {
                    id: "phone",
                    onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fieldErrors.phone && _ctx.validate())),
                    modelValue: _ctx.fields.phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fields.phone = $event)),
                    class: ["mr-1 mb-1", { 'invalid': _ctx.fieldErrors.phone }],
                    placeholder: "Телефон *",
                    mask: "+7 (999) 999-9999"
                  }, null, 8, ["modelValue", "class"])
                ]),
                (_ctx.fieldErrors.phone)
                  ? (_openBlock(), _createBlock(_component_InlineMessage, {
                      key: 0,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validate())),
                      class: "error"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.fieldErrors.phone), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("p", _hoisted_12, [
              _createVNode(_component_Checkbox, {
                id: "isAgreementChecked",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validate())),
                modelValue: _ctx.fields.isAgreementChecked,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fields.isAgreementChecked = $event)),
                binary: true,
                class: ["mr-1", { 'invalid': _ctx.fieldErrors.isAgreementChecked }]
              }, null, 8, ["modelValue", "class"]),
              _hoisted_13,
              _hoisted_14,
              _hoisted_15
            ]),
            (_ctx.fieldErrors.isAgreementChecked)
              ? (_openBlock(), _createBlock(_component_InlineMessage, {
                  key: 1,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validate())),
                  class: "error"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.fieldErrors.isAgreementChecked), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _: 1
  }, 8, ["visible"]))
})